import { Z_INDEX_SECOND } from '../../../../legacy/common/theme'

export const navBarHeight = 48

// Z_INDEX_SECOND is used for all modals, and we want the manu bar to be just below it
export const MENU_BAR_Z_INDEX = Z_INDEX_SECOND - 1
